import { Observable } from 'rxjs';
import { ContentType } from '../../../common';
import { BookmarkItem, SimpleBookmarkItem } from './bookmark-item';

export abstract class AbstractBookmarkService {
  public abstract readonly bookmarksChanged$: Observable<string[]>;
  public abstract findBookmarkOfProgramByGuid(
    guid: string,
    forContentType: 'movie' | 'series' | 'episode' | 'season'
  ): BookmarkItem | undefined;

  public abstract getBookmarkOfContent$(guid: string, contentType: ContentType): Observable<SimpleBookmarkItem>;
}
